import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import { SurveyQuestion } from "../../../types";
import getControlProps from "../helpers/getControlProps";
import callingCodes from "../helpers/callingCodes";

interface Props {
  question: SurveyQuestion;
  error: string;
  onChange: any;
}

interface State {
  callingCode: string;
  country: string;
  answer: string;
}

class VisitorPhoneQuestion extends React.Component<Props, State> {
  defaultCallingCode = callingCodes.filter(
    x => x.name == this.props.question.DefaultSelectText
  );
  state = {
    callingCode: this.defaultCallingCode.length
      ? this.defaultCallingCode[0].callingCode
      : "1",
    country: this.defaultCallingCode.length
      ? this.defaultCallingCode[0].code
      : "US",
    answer: ""
  };

  update = () => {
    setTimeout(() => {
      let input = this.state.answer;
      let answer = this.props.question.UseCountryCode
        ? `${this.state.callingCode}${input}`
        : input;

      if (this.props.question.MaskVisitorPhone) {
        answer = answer.replace(/\D/g, "");
      }

      this.props.onChange(this.props.question, answer);
    }, 0);
  };

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    let answer = e.currentTarget.value;
    if (this.props.question.MaskVisitorPhone) {
      answer = answer.replace(/\D/g, "");
    }
    this.setState({ answer });
    this.update();
  };

  mapCallingCode = (country: any) => {
    const val = `${country.code} (+${country.callingCode})`;
    return (
      <option key={val} value={val}>
        {val}
      </option>
    );
  };

  onChangeCountry = (e: React.FormEvent<HTMLSelectElement>) => {
    let country = e.currentTarget.value
      .substr(0, e.currentTarget.value.indexOf("("))
      .trim();
    let callingCode = e.currentTarget.value
      .substr(e.currentTarget.value.indexOf("(") + 1)
      .replace(")", "")
      .trim();
    this.setState({
      callingCode,
      country
    });
    this.update();
  };

  getCallingCodeValue = () => {
    var callingCode =
      this.state.callingCode.indexOf("+") === -1
        ? `+${this.state.callingCode}`
        : this.state.callingCode;
    return `${this.state.country} (${callingCode})`;
  };

  renderCountryCode() {
    if (!this.props.question.UseCountryCode) {
      return null;
    }

    return (
      <select
        onChange={this.onChangeCountry}
        value={this.getCallingCodeValue()}
        style={{
          width: "120px",
          marginRight: "-1px",
          display: "inline-block"
        }}
      >
        {callingCodes.map(this.mapCallingCode)}
      </select>
    );
  }

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <div style={{ display: "flex" }}>
          {this.renderCountryCode()}
          <input
            type="tel"
            autoComplete="tel"
            placeholder={this.props.question.PlaceholderText}
            value={this.state.answer}
            onChange={this.onChange}
            style={{ display: "inline-block" }}
            {...getControlProps(this.props.question, this.props.error)}
          />
        </div>

        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default VisitorPhoneQuestion;
